module.exports = __webpack_public_path__ + "img/agpz-truck-selected.f1d74b33.svg";